var map = {
	"./music-instructions.json": 4836,
	"./music-library-intro2024.json": 4837,
	"./music-library-launch2024.json": 4838,
	"./music-progression.json": 4839,
	"./startSourcesAdvanced.json": 4840,
	"./startSourcesSimple.json": 4841,
	"./startSourcesSimple2.json": 4842,
	"./startSourcesTracks.json": 4843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4529;